export default __webpack_public_path__ + "static/media/Link.efde6d4f.svg";